import { Elements } from "@stripe/react-stripe-js";

import { stripeElementsOptions, stripePromise } from "./stripe";

type StripeProviderProps = { children: React.ReactNode };

const StripeProvider = ({ children }: StripeProviderProps) => {
  return (
    // Keep params outside of the render function to avoid rerenders
    <Elements stripe={stripePromise} options={stripeElementsOptions}>
      {children}
    </Elements>
  );
};

export default StripeProvider;
